/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { Modal } from 'react-bootstrap'
import './AudioTranscriptionStyle.css'
import '../ModalStyle.css'
import { TranscriptData } from '@dataTypes/message.types'
import AudioWaveform from '@components/common/AudioWaveform/AudioWaveform.component'
import CallSummary from '@components/pages/Messages/MessageCenterChat/templates/CallSummary/CallSummary'
import { useCallRecordingObjectUrl } from '@hooks/useCallRecording'

type AudioTranscriptionProps = {
  audioUrl: string
  show: boolean
  transcript: TranscriptData[]
  toggleModal: any
  aiSummary?: string
}

function AudioTranscription({
  audioUrl,
  show,
  transcript,
  toggleModal,
  aiSummary,
}: AudioTranscriptionProps): React.ReactElement {
  const playbackSrc = useCallRecordingObjectUrl(audioUrl)
  return (
    <>
      <Modal
        show={show}
        onHide={() => toggleModal(!show)}
        centered
        className="mt-0 audio-transcription-container"
      >
        <Modal.Header closeButton>
          <div className="d-flex align-items-center">
            <Modal.Title>Audio transcription</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="audio-transcription-body">
          <AudioWaveform
            audioUrl={playbackSrc}
            orientation="horizontal"
            transcriptData={transcript}
          />
          {aiSummary && (
            <CallSummary
              aiCallSummary={aiSummary}
              showLeftIcon={false}
              senderType="at-modal"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AudioTranscription
